// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__QrDgm","large":"styles_large__306lT"};